var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultBulkEditDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 9.5C18.25 9.5 17.7262 15.9022 17.4194 18.9881C17.369 19.4947 16.9419 19.8757 16.4328 19.876L7.65189 19.8811C7.14227 19.8814 6.7143 19.5 6.66174 18.9931C6.34059 15.8953 5.75 9.5 5.75 9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.55273H4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.55288C15.4225 6.55288 15.0944 5.67353 15.042 4.75719C15.004 4.09153 14.5116 3.5 13.8448 3.5H10.1552C9.48842 3.5 8.99604 4.09153 8.95799 4.75719C8.90562 5.67353 8.57753 6.55288 7.5 6.55288",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultBulkEditDeleteIcon);
export default __webpack_public_path__ + "static/media/vault-bulk-edit-delete-icon.8b97edf42f9cbad8496519f62aa1b84e.svg";
export { ForwardRef as ReactComponent };